/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue'
import axios from '@/axios.js'
import con from "@/firebase/firebaseInit.ts";
import AddToCalendar from 'vue-add-to-calendar'
import ls from "@/common/localStorage"

Vue.use(AddToCalendar);
//var cn = 'OA_UAT_C1591205467009E1591206650065';
var cn = ls.getSessionEventCollectionName();
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');

var FETCHCHECKINLOCATIONAPIURL = con.checkinLocationFetchAPi;
var ADDCHECKINLOCATIONAPIURL = con.checkinLocationAddAPi;
var storageRef = con.storageRef;



export default {
    fetchGeoCheckinLocations({ commit }) {
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                },
                "data": {
                    "includeMappedAttendees": true,
                }
            }
            let headers = {
                "content-type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }

            axios.post(FETCHCHECKINLOCATIONAPIURL, requestData, { headers: headers }).then((response) => {
                if (response.status == 200) {
                    if (response.data.status == 0) {
                        markers.push(response.data.results);
                    }
                }
                console.log("from marker location====",markers);
                
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching page engagement data==:', error)
            })

        })
    },
    addLocation(context, field) {
        return new Promise((resolve, reject) => {
            console.log("field====", field);
            debugger;

            var locImgUrl = "";
            if (field.data.file != null || field.data.file != undefined) {
                const file = field.data.file
                let metadata = {
                    'contentType': file.type
                }
                storageRef.child(cn + '/GeoCheckinLocation/Image/' + (new Date().getTime()) + "_" + file.name).putString(field.data.ImageUrl, 'data_url').then(function (snapshot) {

                    snapshot.ref.getDownloadURL().then(function (url) {
                        locImgUrl = url.toString();
                        let docObj = {};

                       if(field.data.CheckinType ==  'Remote Check-in'){
                        docObj = {
                            Name: field.data.Name ? field.data.Name : "",
                            Address: "",
                            City: "",
                            Country: "",
                            Latitude: 0,
                            Longitude: 0,
                            IsPublished: field.data.IsPublished ? true : false,
                            ZipCode: "",
                            ImageUrl: locImgUrl,
                            CheckinType: field.data.CheckinType,
                            CoveredRadius: 0,
                            OpenLocation: field.data.OpenLocation
                        }
                       }else{
                        docObj = {
                            Name: field.data.Name ? field.data.Name : "",
                            Address: field.data.Address?  field.data.Address : "",
                            City: field.data.City ? field.data.City : "",
                            Country: field.data.Country ? field.data.Country : "",
                            Latitude: field.data.Latitude,
                            Longitude: field.data.Longitude,
                            IsPublished: field.data.IsPublished ? true : false,
                            ZipCode: field.data.ZipCode ? field.data.ZipCode : "",
                            ImageUrl: locImgUrl,
                            CheckinType: field.data.CheckinType,
                            CoveredRadius: parseInt(field.data.Radius),
                            OpenLocation: field.data.OpenLocation
                        }
                       }
                         
                        let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                        let headers = {
                            "Content-Type": "application/json",
                            'Authorization': `Bearer ${accessToken}`,
                        }
                        let requestData = {
                            "key": {
                                "instanceId": "OA_UAT",
                                "clientId": Session_Client_Id,
                                "eventId": Session_Event_Id
                            },
                            "data": docObj,
                        };
                        axios.post(ADDCHECKINLOCATIONAPIURL, requestData, { headers: headers }).then(function (res) {
                            if (res.status == 200) {
                                if (res.data.status == 0) {
                                    resolve({ status: 200, message: 'Location Added Succesfully.' })
                                }
                            }
                        }).catch(function (error) {
                            console.log(error)
                            reject(error)
                        })

                    }).catch(function (error) {
                        //console.log('download url '+error)                
                    })
                }).catch(function (error) {
                    //console.log('imgae upload '+error)                
                })
            } else {
                debugger;
                let docObj = {};
                if(field.data.CheckinType ==  'Remote Check-in'){
                    docObj = {
                        Name: field.data.Name ? field.data.Name : "",
                        Address: "",
                        City: "",
                        Country:"",
                        Latitude: 0,
                        Longitude: 0,
                        IsPublished: field.data.IsPublished ? true : false,
                        ZipCode: "",
                        ImageUrl: "",
                        CheckinType: field.data.CheckinType,
                        CoveredRadius: 0,
                        OpenLocation: field.data.OpenLocation
                    }
                }else{
                     docObj = {
                        Name: field.data.Name ? field.data.Name : "",
                        Address: field.data.Address?  field.data.Address : "",
                        City: field.data.City ? field.data.City : "",
                        Country: field.data.Country ? field.data.Country : "",
                        Latitude: field.data.Latitude,
                        Longitude: field.data.Longitude,
                        IsPublished: field.data.IsPublished ? true : false,
                        ZipCode: field.data.ZipCode ? field.data.ZipCode : "",
                        ImageUrl: "",
                        CheckinType: field.data.CheckinType,
                        CoveredRadius: parseInt(field.data.Radius),
                        OpenLocation: field.data.OpenLocation
                    }
                }
                
                let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                let headers = {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${accessToken}`,
                }
                let requestData = {
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id
                    },
                    "data": docObj,
                };
                axios.post(ADDCHECKINLOCATIONAPIURL, requestData, { headers: headers }).then(function (res) {
                    if (res.status == 200) {
                        if (res.data.status == 0) {
                            resolve({ status: 200, message: 'Location Added Succesfully.' })
                        }
                    }
                }).catch(function (error) {
                    console.log(error)
                    reject(error)
                })
            }

        })
    },
    updateLocation(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": Session_Event_Id,
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT",
                    "locationId": field.id
                },
                "data": {
                    Name: field.data.Name,
                    Address: field.data.Address,
                    City: field.data.City,
                    Country: field.data.Country,
                    Latitude: field.data.Latitude,
                    Longitude: field.data.Longitude,
                    IsPublished: field.data.IsPublished ? true : false,
                    ZipCode: field.data.ZipCode,
                    ImageUrl: field.data.ImageUrl,
                    CheckinType: field.data.CheckinType,
                    CoveredRadius: parseInt(field.data.Radius),
                    OpenLocation: field.data.OpenLocation

                    
                    //LastModifiedDate: new Date()
                }
            }
            axios.put(ADDCHECKINLOCATIONAPIURL, requestData, { headers: headers }).then(response => {
                if (response.status == 200) {
                    if (response.data.status == 0) {
                        resolve({ status: 200, message: 'Location Updated Succesfully.' })
                    }
                } else {
                    resolve({ status: 500, message: 'Location not Updated.' })
                }
            }).catch(function (error) {
                reject(error)
            })
        })
    },
    getDeviceLocation(context){
        return new Promise((resolve, reject) => {
            if(navigator.geolocation){
                navigator.geolocation.getCurrentPosition(resolve, reject);
            }else{
                reject();
            }
        })
    },
    fetchUserInitialLocation(context) {
        return new Promise(async(resolve, reject) => {
            let Coordinates = {lat:0, lng:0};
               await context.dispatch("getDeviceLocation").then(position=>{
                   Coordinates.lat = position.coords.latitude;
                   Coordinates.lng = position.coords.longitude;
               }).catch(err=> console.log(err))

                resolve({
                    status: 200,
                    data: {
                        Latitude: Coordinates.lat,
                        Longitude: Coordinates.lng,
                    }
                })
        })
    },   
}